import { useMemo } from 'react'
import { FileEntryBM } from '@bm-js/atlascloud-shared'
import { uiEnv } from '../env'

interface Props<
  T = {
    uuid: string
    type: string
    name: string
    widths?: { width: number; uuid: string }[]
  }
> extends React.ImgHTMLAttributes<HTMLImageElement> {
  file?: T
  skipPlaceholder?: boolean
}

export type Spotlight = (image?: FileEntryBM) => void

export const ResponsiveImage = ({
  file,
  alt,
  skipPlaceholder,
  ...rest
}: Props) => {
  const src = useMemo(() => {
    return `${uiEnv.s3FilesBase}/uploads/${file?.uuid}`
  }, [file])

  const srcSet = useMemo(() => {
    if (!file?.widths) return undefined
    return file.widths
      .map(({ width, uuid }) => `${uiEnv.s3FilesBase}/compressed/${uuid} ${width}w`)
      .join(', ')
  }, [file?.widths])

  if (!file?.uuid && !skipPlaceholder)
    return (
      <img
        src='/images/image-placeholder.png'
        alt={alt || 'Placeholder'}
        {...rest}
      />
    )

  if (file?.type !== 'image') return null

  return <img src={src} srcSet={srcSet} alt={alt || file.name} {...rest} />
}
